import React from 'react'

export default function CuisineTreat({ data, isCuisine = true, headingTag = "h1" }) {
  const HeadingTag = headingTag;

  return (
    <>
      <section className="cuisine-treat-area">
        <img src={data?.leftImg} alt="cuisine" className="img-responsive" />
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-lg-6 col-md-6 wow animate__animated animate__fadeInRight" data-wow-delay="0.2s" data-wow-duration="1.2s">
              <div className={`cuisine-treat-box`}>
                <div>
                  <span><img src={data?.rightImg} className="img-responsive" alt="cuisine" loading="lazy" /></span>
                </div>
                <HeadingTag className="heading">{data?.title}</HeadingTag>
              </div>
            </div>
          </div>
        </div>
      </section>

      {isCuisine &&
        <section className="cuisine-treact-bottom">
          <div className="container">
            <div className="row justify-content-end">
              <div className="col-lg-9">
                <p dangerouslySetInnerHTML={{ __html: data?.desc }} />
              </div>
            </div>
          </div>
        </section>
      }
    </>
  )
}
